export const SCANNER_TYPE_QR = 'qrs';
export const PRINTER_TYPE_QR = 'qrp';
export const PRINTER_TYPE_SLIP = 'slip';
export const API_SUPPORT_FOR_POS = "SARAS-Ext-POS";